module.exports = __webpack_public_path__ + "img/usability-insights-mobile.d94ffe90.svg";